import React from 'react';
import { useParams } from 'react-router-dom';

function AnalysisPoint() {
  const { pointNumber } = useParams();
  
  return (
    <div className="analysis-point">
      <h1>Punto de Análisis {pointNumber}</h1>
      <p>Contenido específico para el punto {pointNumber}</p>
    </div>
  );
}

export default AnalysisPoint;